import React from 'react'

import { Loader } from '@fourthwall/components'
import { useAbandonedCheckoutRemindersSettings } from '@modules/Dashboard/pages/Settings/pages/Checkout/hooks/useAbandonedCheckoutRemindersSettings'

import { KlaviyoConnected } from './components/KlaviyoConnected'
import { KlaviyoGetStarted } from './components/KlaviyoGetStarted'
import { KlaviyoSetLists } from './components/KlaviyoSetLists'
import { KlaviyoSyncJobActive } from './components/KlaviyoSyncJobActive'
import { useKlaviyo } from './hooks/useKlaviyo'

const DEFAULT_SYNC_JOB_KEYS = [
  'MEMBERS' as const,
  'NEWSLETTER' as const,
  'OFFERS' as const,
  'PROMOTIONS' as const,
  'COLLECTIONS' as const,
]

export const AppsKlaviyoSettings = () => {
  const {
    klaviyo,
    syncStatus,
    // actions
    refreshLists,
    isRefreshing,
    setLists,
    isSettingLists,
    createSyncJob,
    isCreatingSyncJob,
  } = useKlaviyo()

  const { abandonedCheckoutRemindersSettings } = useAbandonedCheckoutRemindersSettings()
  const isOff =
    abandonedCheckoutRemindersSettings.initialValues.abandonedCheckoutEmailFrequency === 'off'

  if (!klaviyo.configuration) {
    return <Loader />
  }

  // Show get started button if fetchedLists is false
  if (!klaviyo.configuration.fetchedLists || !klaviyo.configuration.lists) {
    return <KlaviyoGetStarted refreshLists={refreshLists} isRefreshing={isRefreshing} />
  }

  // Show list configuration if lists haven't been set
  if (!klaviyo.configuration.membersListId && !klaviyo.configuration.newsletterListId) {
    return (
      <KlaviyoSetLists
        lists={klaviyo.configuration.lists}
        setLists={setLists}
        isSettingLists={isSettingLists}
        refreshLists={refreshLists}
        isRefreshing={isRefreshing}
        membersListId={klaviyo.configuration.membersListId}
        newsletterListId={klaviyo.configuration.newsletterListId}
      />
    )
  }

  // Show active sync status
  if (syncStatus.active) {
    return <KlaviyoSyncJobActive status={syncStatus.progress} />
  }

  // Show connected state
  return (
    <KlaviyoConnected
      createSyncJob={() => createSyncJob({ keys: DEFAULT_SYNC_JOB_KEYS })}
      isCreatingSyncJob={isCreatingSyncJob}
      hasSynced={syncStatus.hasSynced}
      recentSync={syncStatus.recent}
      abandonedCheckoutIsOff={isOff}
      dataCount={klaviyo.configuration.dataCount ?? 0}
    />
  )
}
